import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';
import { tourStatusUtils } from '@/features/dashboard/tours/types/TourStatus.utils.ts';

export const TourStatusFilterInput = ({ form, index }: FilterInputProps) => (
  <MultiSelectInput
    controlSize="toolbar"
    placeholder="Wpisz wartość"
    fieldPath={`filters.${index}.value`}
    control={form.control}
    options={[
      {
        value: TourStatus.DRAFT,
        label: tourStatusUtils.getLabel(TourStatus.DRAFT),
      },
      {
        value: TourStatus.READY,
        label: tourStatusUtils.getLabel(TourStatus.READY),
      },
      {
        value: TourStatus.CANCELLED,
        label: tourStatusUtils.getLabel(TourStatus.CANCELLED),
      },
      {
        value: TourStatus.ARCHIVED,
        label: tourStatusUtils.getLabel(TourStatus.ARCHIVED),
      },
    ]}
  />
);
